import VendorUploadContainer from '@components/containers/vendorUpload';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const VendorUpload: FC = () => (
    <VendorLayout>
        <VendorUploadContainer />
    </VendorLayout>
);

export default VendorUpload;
